export class Orgstyle {
    organizationId:string;
    whitelabelId:string;
    mainColor:string;
    negMainColor:string;
    borderRad:string;
    orgFont:string;
    orgContentFont:string;
    orgFontColor:string;
    buttontextColor:string;
    orgBrandWeight:string;
    brandControl:string;
    logoformat:string;
    sidenav:string;
    orgfavicon:string;
    buttonbgcolor:string;
    buttonbghovercolor:string;
    orgtitlecolor:string;
    navborder:string;
    orgiconColor:string;
    buttontextHoverColor:string;
    orgiconhoverColor:string;
    dropdowntextcolor:string;
    tabletextcolor:string;
    plannerdaycolor:string;
    customerpagelabelcolor:string;
    infopinhoverbgcolor:string;
    infopinbgcolor:string;
    footertextcolor:string;
}